<template>
  <div :class="{ 'h5-coupon-list': isH5 }">
    <el-table :data="list" style="width: 100%">
      <template slot="empty">
        <empty />
      </template>
      <el-table-column label="优惠券名" prop="coupon_name"> </el-table-column>
      <el-table-column label="优惠信息" width="120">
        <template slot-scope="scope">
          <p v-if="scope.row.coupon_type === 1">
            立减￥{{ scope.row.amount / 100 }}
          </p>
          <p v-if="scope.row.coupon_type === 2">
            折扣{{ scope.row.ratio / 10 }}折
          </p>
        </template>
      </el-table-column>
      <el-table-column label="领取时间" width="160">
        <template slot-scope="scope">
          {{
            moment(scope.row.created_at * 1000).format("YYYY-MM-DD HH:mm:ss")
          }}
        </template>
      </el-table-column>
      <el-table-column label="使用期限" width="330">
        <template slot-scope="scope">
          {{
            moment(scope.row.use_start_time * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          }}至{{
            moment(scope.row.use_end_time * 1000).format("YYYY-MM-DD HH:mm:ss")
          }}
        </template>
      </el-table-column>
      <el-table-column label="关联课程" width="120">
        <template slot-scope="scope">
          <el-button
            class="btn-blue--text"
            type="text"
            @click="showCouponDetail(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="page-wrap"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="pageInfo.page"
      :total="pageInfo.total"
      :page-sizes="[10, 15, 20, 30]"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import moment from "moment";
import { getCouponList } from "@saas/service-api/src/coupon";
export default {
  data: function () {
    return {
      moment,
      list: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      isH5: false,
    };
  },
  mounted() {
    this.isH5 = isH5();
    this.getList();
  },
  methods: {
    showCouponDetail(obj) {
      this.$router.push(`/coupon-detail/${obj.coupon_id}`);
    },
    handleChangePage(page) {
      this.pageInfo.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.getList();
    },
    getList() {
      getCouponList({
        page_no: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
      })
        .then((res) => {
          const { code, data, message } = res;
          if (code === 1) {
            this.list = data.list || [];
            this.pageInfo.total = data.total;
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  margin-top: 45px;
  text-align: right;
}
::v-deep .el-table {
  background: var(--card-bg, #ffffff);
  color: var(--text-primary, #1d2129);

  &::before,
  &::after {
    background-color: var(--border-subtle, #ebeef5);
  }

  th.el-table__cell,
  thead,
  tr,
  td.el-table__cell {
    background: var(--card-bg, #ffffff);
    border-bottom-color: var(--border-subtle, #ebeef5);
  }

  thead {
    color: var(--text-secondary, rgba(34, 34, 34, 0.6));
  }

  th.el-table__cell {
    background: var(--input-bg, #f2f3f5);
    color: var(--text-secondary, rgba(34, 34, 34, 0.6));
  }

  .cell,
  .el-table__empty-text {
    color: var(--text-primary, #1d2129);
  }
}
::v-deep .el-pagination {
  color: var(--text-secondary, rgba(34, 34, 34, 0.8));

  .el-pagination__total,
  .el-pagination__jump,
  .btn-prev,
  .btn-next,
  .el-pager li {
    color: var(--text-secondary, rgba(34, 34, 34, 0.8));
  }

  .el-input__inner,
  .el-pager li,
  .btn-prev,
  .btn-next {
    background: var(--input-bg, #f2f3f5);
    border-color: var(--border-subtle, transparent);
  }

  .el-pager li.active {
    background: rgba(0, 200, 157, 0.14);
    color: #00c89d;
  }
}
.h5-coupon-list {
  ::v-deep .el-pagination {
    display: flex;
    flex-wrap: wrap;
    .el-pagination__total {
      margin-left: 10px;
      margin-bottom: 8px;
    }
    .el-pagination__sizes {
      width: calc(100% - 90px);
      text-align: left;
      margin-bottom: 8px;
    }
    .el-pagination__jump {
      width: 100%;
      text-align: left;
      margin-left: 10px;
      margin-top: 8px;
    }
  }
}
</style>
